import { InputPadrao, InputDatePicker, InputTimePicker, TextArea } from '../../../../components/Inputs'
import { InputBeneficiario, InputPrestador, InputPrestadorConselho, InputPrestadorEspecialidade, InputStatusAgenda } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect, useRef } from 'react'
import Yup, { validaHora } from '../../../../util/Validacoes'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import { salvar, get, acoesAgenda } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'
import { ACOES, AGENDA_STATUS, MODULO } from '../../../../util/Enums'
import moment from 'moment'
import { ModalCadastro } from '../../../../components/Modais'
import { getUsuario } from '../../../../util/Configuracoes'
import { LoadRelatorio } from '../../../../components/Loading'

//---------------------------------------------------------------------
const CadastroRapidoSuspensa = (props) => {
    let id = props.id
    const user = getUsuario()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [refPaciente, setRefPaciente] = useState({})
    const [showModalInterOcorrencia, setShowModalInterOcorrencia] =
        useState(false)
    const [msgValidacao, setMsgValidacao] = useState([])
    const [tituloValidacao, setTituloValidacao] = useState('')
    const [dataAtual, setDataAtual] = useState(new moment().format('DD/MM/YYYY'))

    const [validacao] = useState(
        Yup.object({
            prestador: Yup.string().nullable().required(),
            data: Yup.string().nullable().required(),
            hora_inicial: Yup.string()
                .required()
                .test('Hora Inicial', 'Hora inválida!', function (value) {
                    return validaHora(this.parent.hora_inicial)
                }),
            hora_final: Yup.string().test(
                'Hora Final',
                'Hora inválida!',
                function (value) {
                    return validaHora(this.parent.hora_final)
                },
            ),
            observacao: Yup.string().nullable().max(500),
        })
    )

    useEffect(() => {
        if (id) {

        }
    }, [props.id])

    const manter = [
        'data_inicial',
    ]

    useEffect(() => {
        if (refPaciente.current) {
            refPaciente.current.focus()
        }
    }, [refPaciente])

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        setShowModalInterOcorrencia(false)
        let valoresFormatados = { ...values }
        salvar(
            valoresFormatados,
            '/atendimento/agenda',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                propsFormik.resetForm({})
                manter.forEach((x) => propsFormik.setFieldValue(x, values[x]))
                setSalvando(false)
                setSalvarENovo(false)
                refPaciente.current.focus()

                const scrollOffset = window.pageYOffset
                // props.setAbrirModal(false)
                props.funcaoAposSalvar()
                setTimeout(() => {
                    window.scrollTo({
                        top: scrollOffset,
                        left: 0,
                        behavior: 'smooth',
                    })
                }, 500)
            },
            (err) => {
                setSalvando(false)
            },
        )
    }

    useEffect(() => {
        if (props.id) {
            Promise.resolve(get(`/atendimento/agenda/${props.id}`)).then(
                (val) => {
                    setValoresIniciais(val)
                },
            )
        } else {
            setValoresIniciais({
                prestador: '',
                data_inicial: '',
                hora_inicial: '',
                hora_final: '',
                observacao: '',
            })
        }
    }, [props.id])

    const funcaoCancelar = (propsFormik) => {
        props.setAbrirModal(false)
    }

    return (
        <>
            {props.abrirModal ? (
                <Formik
                    initialValues={valoresIniciais}
                    validationSchema={validacao}
                    enableReinitialize={true}
                    onSubmit={(values, propsFormik) =>
                        Submit(values, propsFormik)
                    }
                >
                    {(propsFormik) => (
                        <Form>
                            <div className="modal-body-cadastro">
                                <InputPadrao
                                    label="Id"
                                    name="id"
                                    type="hidden"
                                    placeholder="Id"
                                    obrigatorio={true}
                                    tamanho=" m-1"
                                />
                                <div className="row">
                                    <div className='row col-9'>

                                        <InputBeneficiario
                                            setReference={setRefPaciente}
                                            ref={refPaciente}
                                            label="Paciente"
                                            placeholder="Paciente"
                                            name="paciente"
                                            propsFormik={propsFormik}
                                            obrigatorio={true}
                                            tamanho={'col-6'}
                                            classeTooltip={'tooltip-input-modal'}
                                            focarAposSubmit={true}
                                            salvarENovo={salvarENovo}
                                            autoFocus
                                            botaoVisivel={true}
                                        />

                                        <InputPrestadorConselho
                                            label="Prestador"
                                            placeholder="Prestador"
                                            name="prestador"
                                            propsFormik={propsFormik}
                                            obrigatorio={true}
                                            tamanho={'col-6'}
                                            classeTooltip={'tooltip-input-modal'}
                                            focarAposSubmit={true}
                                            salvarENovo={salvarENovo}
                                            autoFocus
                                            onChangeOption={() => {
                                                propsFormik.setFieldValue('especialidade', null)
                                            }}
                                        />


                                        <InputDatePicker
                                            id={'data'}
                                            navigation
                                            tamanho={'col-3'}
                                            label="Data"
                                            name="data"
                                            type="text"
                                            obrigatorio="true"
                                            autoFocus
                                            setarValor={(value) => {
                                                propsFormik.setFieldValue('data', value)
                                                setDataAtual(value)
                                            }}
                                            classeTooltip={props.modal && 'tooltip-input-modal'}
                                            mostrarFeriado={true}
                                        />
                                        <InputTimePicker
                                            label="Hora Inicial"
                                            mascara="11:11"
                                            name="hora_inicial"
                                            type="text"
                                            placeholder="Hora Inicial"
                                            tamanho={'col-3'}
                                            obrigatorio={true}
                                            classeTooltip={props.modal && 'tooltip-input-modal'}
                                            setarValor={(value) => {
                                                propsFormik.setFieldValue('hora_inicial', value)
                                            }}
                                        />
                                        <InputTimePicker
                                            label="Hora Final"
                                            mascara="11:11"
                                            name="hora_final"
                                            type="text"
                                            placeholder="Hora Final"
                                            tamanho={'col-3'}
                                            classeTooltip={props.modal && 'tooltip-input-modal'}
                                            setarValor={(value) => {
                                                propsFormik.setFieldValue('hora_final', value)
                                            }}
                                        />

                                        <InputPrestadorEspecialidade
                                            label="Especialidade"
                                            placeholder="Especialidade"
                                            name="especialidade"
                                            propsFormik={propsFormik}
                                            obrigatorio={true}
                                            tamanho={'col-3'}
                                            classeTooltip={'tooltip-input-modal'}
                                            focarAposSubmit={true}
                                            salvarENovo={salvarENovo}
                                            prestador={propsFormik.values.prestador}
                                            autoFocus
                                        />
                                    </div>
                                    <div className='col-3 row pr-0'>
                                        <TextArea
                                            label="Observação"
                                            name="observacao"
                                            type="text"
                                            placeholder="Observação"
                                            tamanho={'col-12'}
                                            classeTooltip={props.modal && 'tooltip-input-modal'}
                                            rows={5}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="text-right container-botoes mb-3 group-salvar-novo mt-2">
                                <Atalho formik={propsFormik} salvando={salvando} />
                                <BotaoPadrao
                                    texto="Salvar"
                                    disabled={salvando}
                                    click={(_) => { }}
                                    idTooltip={'salvar'}
                                    classeTooltip="tooltip-plantao-es"
                                    class="btn btn-primary-sm primary"
                                />
                                <BotaoPadrao
                                    texto="Cancelar"
                                    type="button"
                                    disabled={salvando}
                                    click={(_) => funcaoCancelar(propsFormik)}
                                    idTooltip={'cancelar'}
                                    classeTooltip="tooltip-plantao-es"
                                    class="btn btn-primary-sm primary"
                                />
                            </div>
                            {/* <ModalDuasOpcoes
                                showModal={showModalInterOcorrencia}
                                setShowModal={setShowModalInterOcorrencia}
                                funcaoOpcao2={() => Submit(propsFormik.values, propsFormik)}
                                funcaoOpcao1={() => {
                                    setSalvando(false)
                                    setShowModalInterOcorrencia(false)
                                }}
                                esconderFechar
                                mensagem={
                                    <>
                                        {tituloValidacao ? (
                                            <>
                                                {tituloValidacao} <br />
                                                <br />
                                            </>
                                        ) : (
                                            <></>
                                        )}{' '}
                                        {msgValidacao}
                                        <br />
                                    </>
                                }
                                textoOpcao1={'Cancelar'}
                                classeOpcao1={'btn-sm btn-primary-modal simples'}
                                textoOpcao2={'Continuar'}
                            /> */}
                        </Form>
                    )}
                </Formik>
            ) : (
                <></>
            )}
        </>
    )
}

const TrocarStatus = (props) => {
    const [salvando, setSalvando] = useState(false)
    const [item, setItem] = useState({})
    const [carregando, setCarregando] = useState(true)
    const refAtualizacao = useRef(null)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')

    const [validacao, setValidacao] = useState({})

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        let valuesAjustados = { ...values }

        acoesAgenda(
            valuesAjustados,
            '/atendimento/agendastatus',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                setSalvando(false)
                props.setAbrirModal(false)
                props.funcaoAposSalvar()
            },
            () => setSalvando(false),
            null,
            ACOES.ALTERAR_STATUS_AGENDA,
            MODULO['/atendimento/agendastatus']
        )
    }

    const obterAgenda = () => {
        setCarregando(true)
        Promise.resolve(get(`/atendimento/agenda/${props.item.id}`)).then(
            (val) => {
                let obj = { ...val }
                const hora = []
                hora.push(val.hora_inicial)
                if (val.hora_final) hora.push(val.hora_final)

                obj.horario = hora.join(' - ')
                setItem(obj)
                setValoresIniciais({
                    id: props.item.id,
                    status: { value: obj.status_id, label: obj.status },
                    consultorio: obj.status_id == AGENDA_STATUS.EM_ESPERA ? obj.consultorio : '',
                    hora_inicial: obj.hora_inicial,
                    hora_final: obj.hora_final,
                    data: obj.data
                })
                setCarregando(false)
            },
        )

        setValidacao(
            Yup.object({
                status: Yup.object().nullable().required(),
                observacao: Yup.string().nullable(),
                consultorio: Yup.string().when('status.value', {
                    is: AGENDA_STATUS.EM_ESPERA,
                    then: Yup.string().required(),
                    otherwise: Yup.string().nullable(),
                }),
                hora_inicial: Yup.string().when('status.value', {
                    is: AGENDA_STATUS.REAGENDADO,
                    then: Yup.string().required(),
                    otherwise: Yup.string().nullable(),
                }),
                data: Yup.string().when('status.value', {
                    is: AGENDA_STATUS.REAGENDADO,
                    then: Yup.string().required(),
                    otherwise: Yup.string().nullable(),
                }),
            }),
        )
    }

    useEffect(() => {
        if (props.item && props.item.id) {
            obterAgenda()
        }
    }, [props.item])

    const funcaoAposSim = (formik) => {
        Submit(formik.values, formik.resetForm)
    }

    return (
        <>
            <ModalCadastro
                titulo={props.titulo}
                show={props.abrirModal}
                setShowModal={props.setAbrirModal}
            >
                <Formik
                    initialValues={valoresIniciais}
                    validationSchema={validacao}
                    enableReinitialize={true}
                    onSubmit={(values, propsFormik) => Submit(values, propsFormik)}
                >
                    {(propsFormik) => (
                        <div ref={refAtualizacao}>
                            <Form>
                                <div className="modal-body-cadastro">
                                    <div class="separator mt-20 mb-20"></div>
                                    <div className={'form-group col-12 row'}>
                                        {carregando === true ? (
                                            <LoadRelatorio refLoading={refAtualizacao} heigth={320} />
                                        ) : props.item && props.item.id ? (
                                            <>
                                                <InputPadrao
                                                    label="Id"
                                                    name="id"
                                                    type="hidden"
                                                    placeholder="Id"
                                                    obrigatorio={true}
                                                />
                                                <label className={'width-100 bold'}>Horário</label>
                                                <label className={'width-100 mb-20'}>
                                                    {item.horario || '--'}
                                                </label>
                                                <label className={'width-100 bold'}>Prestador</label>
                                                <label className={'width-100 mb-20'}>
                                                    {item.prestador?.label || '--'}
                                                </label>
                                                <InputStatusAgenda
                                                    label={<b>Status Agenda</b>}
                                                    name="status"
                                                    placeholder="Status"
                                                    propsFormik={propsFormik}
                                                    tamanho={'col-lg-12 p-0'}
                                                    classeTooltip={'tooltip-input-modal'}
                                                    autoFocus
                                                    obrigatorio
                                                />

                                                {propsFormik.values?.status?.value == AGENDA_STATUS.EM_ESPERA ?
                                                    <InputPadrao
                                                        propsFormik={propsFormik}
                                                        label="Consultório"
                                                        name="consultorio"
                                                        placeholder="Consultorio"
                                                        tamanho={'col-lg-12 p-0'}
                                                        obrigatorio={true}
                                                        classeTooltip={'tooltip-input-modal'} /> :
                                                    <></>
                                                }

                                                {propsFormik.values?.status?.value == AGENDA_STATUS.REAGENDADO ? <>

                                                    <InputDatePicker
                                                        id={'data'}
                                                        navigation
                                                        tamanho={'col-12 p-0'}
                                                        label="Data"
                                                        name="data"
                                                        type="text"
                                                        obrigatorio="true"
                                                        autoFocus
                                                        setarValor={(value) => {
                                                            propsFormik.setFieldValue('data', value)
                                                        }}
                                                        classeTooltip={'tooltip-input-modal'}
                                                        mostrarFeriado={true}
                                                    />
                                                    <InputTimePicker
                                                        label="Hora Inicial"
                                                        mascara="11:11"
                                                        name="hora_inicial"
                                                        type="text"
                                                        placeholder="Hora Inicial"
                                                        tamanho={'col-6 pl-0'}
                                                        obrigatorio={true}
                                                        classeTooltip={'tooltip-input-modal'}
                                                        setarValor={(value) => {
                                                            propsFormik.setFieldValue('hora_inicial', value)
                                                        }}
                                                    />
                                                    <InputTimePicker
                                                        label="Hora Final"
                                                        mascara="11:11"
                                                        name="hora_final"
                                                        type="text"
                                                        placeholder="Hora Final"
                                                        tamanho={'col-6 pr-0'}
                                                        classeTooltip={'tooltip-input-modal'}
                                                        setarValor={(value) => {
                                                            propsFormik.setFieldValue('hora_final', value)
                                                        }}
                                                    />
                                                </> : <></>}

                                                <TextArea
                                                    label={<b>Observação</b>}
                                                    name="observacao"
                                                    type="text"
                                                    placeholder="Observação"
                                                    tamanho={'col-lg-12 p-0'}
                                                    classeTooltip={'tooltip-input-modal'}
                                                />
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                                <div className="separator mt-40 mb-2"></div>
                                {carregando === true ? (
                                    <></>
                                ) : (
                                    <div className="direita container-botoes mb-3 group-salvar-novo">
                                        <BotaoPadrao
                                            texto="Salvar"
                                            disabled={salvando}
                                            click={(_) => { }}
                                            idTooltip={'salvar'}
                                        />
                                    </div>
                                )}
                            </Form>
                        </div>
                    )}
                </Formik>
            </ModalCadastro>
        </>
    )
}

export { CadastroRapidoSuspensa, TrocarStatus }